import React, { useRef } from "react";
import { motion, useMotionValue, useTransform } from "framer-motion";
import { cssVars } from "../theme";
import "./HlcContactSection.css";

const REDUCED_MOTION =
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const fadeUp = {
  hidden: { opacity: 0, y: 22 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
};
const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09 } },
};
const staggerItem = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

/* Same social hrefs/icons as before — reused verbatim, not re-invented. */
const socialLinks = [
  {
    href: "https://www.facebook.com/HLCPK1/",
    aria: "Facebook",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987H7.898v-2.89h2.54V9.845c0-2.507 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562v1.875h2.773l-.443 2.89h-2.33V21.88C18.343 21.128 22 16.991 22 12z" />
      </svg>
    ),
  },
  {
    href: "https://www.instagram.com/hlcpk/",
    aria: "Instagram",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    href: "https://www.linkedin.com/company/high-lite-concern/",
    aria: "LinkedIn",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    href: "https://wa.me/923702961896",
    aria: "WhatsApp",
    icon: (
      <svg viewBox="0 0 32 32" fill="currentColor">
        <path d="M19.11 17.21c-.27-.14-1.58-.78-1.82-.87-.24-.09-.42-.14-.6.14-.18.27-.69.87-.85 1.05-.16.18-.31.2-.58.07-.27-.14-1.13-.42-2.16-1.33-.8-.71-1.34-1.58-1.5-1.85-.16-.27-.02-.41.12-.54.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.14-.6-1.45-.82-1.98-.22-.53-.44-.46-.6-.47h-.51c-.18 0-.47.07-.71.34-.24.27-.93.91-.93 2.22s.95 2.58 1.08 2.76c.13.18 1.87 2.85 4.53 4 .63.27 1.13.43 1.51.55.64.2 1.22.17 1.68.1.51-.08 1.58-.65 1.8-1.28.22-.63.22-1.17.16-1.28-.07-.11-.24-.18-.51-.31z" />
        <path d="M16.01 3C8.83 3 3 8.82 3 16c0 2.53.74 4.98 2.14 7.08L3 29l6.1-2.09A12.93 12.93 0 0 0 16.01 29C23.18 29 29 23.18 29 16S23.18 3 16.01 3zm0 23.67c-2.15 0-4.25-.58-6.09-1.68l-.44-.26-3.62 1.24 1.18-3.53-.29-.46A10.62 10.62 0 0 1 5.33 16c0-5.89 4.79-10.68 10.68-10.68S26.69 10.11 26.69 16 21.9 26.67 16.01 26.67z" />
      </svg>
    ),
  },
];

const BulbIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.44 1 1.2 1 2.1h5c0-.9.4-1.66 1-2.1A6 6 0 0 0 12 3z" />
  </svg>
);
const BuildingIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 21V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v16M12 21v-8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8M4 21h16M7 8h1M7 12h1M7 16h1" />
  </svg>
);
const ShieldCheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l8 3v6c0 5-3.4 9-8 11-4.6-2-8-6-8-11V5z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);
const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 3" />
  </svg>
);
const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);
const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);
const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor">
    <path d="M19.11 17.21c-.27-.14-1.58-.78-1.82-.87-.24-.09-.42-.14-.6.14-.18.27-.69.87-.85 1.05-.16.18-.31.2-.58.07-.27-.14-1.13-.42-2.16-1.33-.8-.71-1.34-1.58-1.5-1.85-.16-.27-.02-.41.12-.54.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.14-.6-1.45-.82-1.98-.22-.53-.44-.46-.6-.47h-.51c-.18 0-.47.07-.71.34-.24.27-.93.91-.93 2.22s.95 2.58 1.08 2.76c.13.18 1.87 2.85 4.53 4 .63.27 1.13.43 1.51.55.64.2 1.22.17 1.68.1.51-.08 1.58-.65 1.8-1.28.22-.63.22-1.17.16-1.28-.07-.11-.24-.18-.51-.31z" />
    <path d="M16.01 3C8.83 3 3 8.82 3 16c0 2.53.74 4.98 2.14 7.08L3 29l6.1-2.09A12.93 12.93 0 0 0 16.01 29C23.18 29 29 23.18 29 16S23.18 3 16.01 3zm0 23.67c-2.15 0-4.25-.58-6.09-1.68l-.44-.26-3.62 1.24 1.18-3.53-.29-.46A10.62 10.62 0 0 1 5.33 16c0-5.89 4.79-10.68 10.68-10.68S26.69 10.11 26.69 16 21.9 26.67 16.01 26.67z" />
  </svg>
);
const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);
const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12M7 10l5 5 5-5M5 21h14" /></svg>
);

export default function HlcContactSection() {
  const rootRef = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const atmoX = useTransform(mx, [0, 1], [-6, 6]);
  const atmoY = useTransform(my, [0, 1], [-6, 6]);

  function handleMouseMove(e) {
    if (REDUCED_MOTION) return;
    const rect = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - rect.left) / rect.width);
    my.set((e.clientY - rect.top) / rect.height);
  }

  /* Preserved exactly from the original component — same target file,
     same download-via-temporary-anchor technique. */
  const handleDownloadCatalog = () => {
    const link = document.createElement("a");
    link.href = "/HLC-Catalog.pdf";
    link.download = "HLC-Catalog.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section
      id="hlc-contact-main"
      className="hcs"
      aria-label="Lighting Consultation"
      style={cssVars}
      ref={rootRef}
      onMouseMove={handleMouseMove}
    >
      <div className="hcs__atmosphere" aria-hidden="true">
        <motion.div className="hcs__glow" style={REDUCED_MOTION ? undefined : { x: atmoX, y: atmoY }} />
        <div className="hcs__ray hcs__ray--a" />
        <div className="hcs__ray hcs__ray--b" />
        <div className="hcs__ray hcs__ray--c" />
      </div>

      <div className="hcs__wrap">
        <motion.div
          className="hcs__header"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.4 }}
        >
          <span className="hcs__eyebrow">Lighting Consultation</span>
          <h2 className="hcs__title">
            Let's Plan Your
            <br />
            Next <span className="hcs__accent">Lighting Project</span>
          </h2>
          <p className="hcs__desc">
            Tell us about your space, project or lighting requirements. Our team
            will help you find the right HLC LED solution.
          </p>
        </motion.div>

        <motion.div
          className="hcs__infocards"
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.div className="hcs__infocard" variants={staggerItem}>
            <span className="hcs__infoicon"><BuildingIcon /></span>
            <div>
              <h4>Expert Support</h4>
              <p>Dedicated lighting specialists</p>
            </div>
          </motion.div>
          <motion.div className="hcs__infocard" variants={staggerItem}>
            <span className="hcs__infoicon"><ShieldCheckIcon /></span>
            <div>
              <h4>Genuine Quality</h4>
              <p>100% genuine HLC products</p>
            </div>
          </motion.div>
          <motion.div className="hcs__infocard" variants={staggerItem}>
            <span className="hcs__infoicon"><ClockIcon /></span>
            <div>
              <h4>Quick Response</h4>
              <p>We usually respond within 24 hours</p>
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          className="hcs__contactcards"
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.a href="tel:+923702961896" className="hcs__contactcard" variants={staggerItem}>
            <span className="hcs__contacticon"><PhoneIcon /></span>
            <span className="hcs__contactlabel">Call Us</span>
            <span className="hcs__contactvalue">+92 370 2961896</span>
            <span className="hcs__contacthint">Mon – Sat, 10:00am – 7:00pm</span>
          </motion.a>

          <motion.div className="hcs__contactcard" variants={staggerItem}>
            <span className="hcs__contacticon"><WhatsAppIcon /></span>
            <span className="hcs__contactlabel">WhatsApp</span>
            <a href="https://wa.me/923702961896" className="hcs__contactvalue" target="_blank" rel="noopener noreferrer">
              +92 370 2961896
            </a>
            <a href="https://wa.me/923422151662" className="hcs__contactvalue" target="_blank" rel="noopener noreferrer">
              +92 342 2151662
            </a>
            <span className="hcs__contacthint">Send drawings, BOQs or project details</span>
          </motion.div>

          <motion.a href="mailto:info@hlcpk.com" className="hcs__contactcard" variants={staggerItem}>
            <span className="hcs__contacticon"><MailIcon /></span>
            <span className="hcs__contactlabel">Email</span>
            <span className="hcs__contactvalue">info@hlcpk.com</span>
            <span className="hcs__contacthint">We usually respond within 24 hours</span>
          </motion.a>
        </motion.div>

        <motion.div
          className="hcs__panel"
          variants={fadeUp}
          initial={{ opacity: 0, y: 25, scale: 0.98 }}
          whileInView={{ opacity: 1, y: 0, scale: 1, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <div className="hcs__panel-glow" aria-hidden="true" />
          <div className="hcs__panel-head">
            <span className="hcs__panel-icon"><BulbIcon /></span>
            <h3>Start Your Project</h3>
            <p>Tell us what you're building, renovating or illuminating.</p>
            <span className="hcs__panel-rule" />
          </div>

          <form className="hcs__form" method="post" noValidate>
            <div className="hcs__form-grid">
              <div className="hcs__field">
                <label htmlFor="hlc-name">Full Name</label>
                <input type="text" id="hlc-name" name="name" placeholder="Enter your full name" required />
              </div>
              <div className="hcs__field">
                <label htmlFor="hlc-phone">Phone</label>
                <input type="tel" id="hlc-phone" name="phone" placeholder="+92 XXX XXXXXXX" required />
              </div>
            </div>

            <div className="hcs__form-grid">
              <div className="hcs__field">
                <label htmlFor="hlc-email">Email Address</label>
                <input type="email" id="hlc-email" name="email" placeholder="your@email.com" />
              </div>
              <div className="hcs__field">
                <label htmlFor="hlc-project-type">Project Type</label>
                <div className="hcs__select-wrap">
                  <select id="hlc-project-type" name="project_type" defaultValue="">
                    <option value="">Select project type</option>
                    <option value="residential">Residential</option>
                    <option value="commercial">Commercial / Office</option>
                    <option value="retail">Retail / Showroom</option>
                    <option value="industrial">Industrial / Warehouse</option>
                    <option value="outdoor">Outdoor / Landscape</option>
                    <option value="other">Other</option>
                  </select>
                  <span className="hcs__select-chevron" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6" /></svg>
                  </span>
                </div>
              </div>
            </div>

            <div className="hcs__field hcs__field--full">
              <label htmlFor="hlc-location">City / Location</label>
              <input type="text" id="hlc-location" name="location" placeholder="e.g. Karachi, Lahore, Islamabad" />
            </div>

            <div className="hcs__field hcs__field--full">
              <label htmlFor="hlc-message">Project Details</label>
              <textarea
                id="hlc-message"
                name="message"
                rows="4"
                placeholder="Tell us about your space, quantity, timelines, or share any specific lighting requirements."
              />
            </div>

            <div className="hcs__actions">
              <button type="submit" className="hcs__btn hcs__btn--primary">
                Send Project Inquiry <ArrowIcon />
              </button>
              <button type="button" className="hcs__btn hcs__btn--ghost" onClick={handleDownloadCatalog}>
                Download Catalog <DownloadIcon />
              </button>
            </div>

            <p className="hcs__note">
              By submitting this form, you agree to be contacted by HLC Pakistan regarding your project.
            </p>
          </form>
        </motion.div>

        <motion.div
          className="hcs__trust"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.5 }}
        >
          Nationwide Delivery <span className="sep">•</span> Genuine HLC Warranty{" "}
          <span className="sep">•</span> Project-Based Support
        </motion.div>

        <motion.div
          className="hcs__social"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.5 }}
        >
          <span className="hcs__social-label">Follow HLC</span>
          <div className="hcs__social-row">
            {socialLinks.map((soc) => (
              <a key={soc.aria} href={soc.href} aria-label={soc.aria} title={soc.aria} target="_blank" rel="noopener noreferrer" className="hcs__soc-link">
                {soc.icon}
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
